import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    
    return ( 
        <footer className="footer">

            <div className='footer-container'>
                <p className="text-center">&copy; 2023 Viver Espírita. Todos os direitos reservados. Desenvolvido por Ricardo Otomar Maria da Silva.</p>
            </div>
            
            <div className='footer-container'>
                <div className="footer-container--collumn">
                    <h5>Contato</h5>
                    <p>contato@viverespirita.com.br</p>
                </div>

                <div className="footer-container--collumn">
                    <ul className="footer-lista">
                        <li><Link to="/politica-privacidade">Política de Privacidade</Link></li>                
                    </ul>
                </div>
            </div>

            
            
        </footer>

    )
}

export default Footer;